"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationManagerQueueReadyEvent = exports.NotificationType = exports.NotificationManagerQueue = exports.NotificationManager = exports.NotificationComponent = void 0;
const notification_1 = require("./domain/notification");
Object.defineProperty(exports, "NotificationComponent", { enumerable: true, get: function () { return notification_1.NotificationComponent; } });
const notification_manager_1 = require("./domain/notification-manager");
Object.defineProperty(exports, "NotificationManager", { enumerable: true, get: function () { return notification_manager_1.NotificationManager; } });
const notification_type_1 = require("./enums/notification-type");
Object.defineProperty(exports, "NotificationType", { enumerable: true, get: function () { return notification_type_1.NotificationType; } });
const notification_manager_queue_1 = require("./domain/notification-manager-queue");
Object.defineProperty(exports, "NotificationManagerQueue", { enumerable: true, get: function () { return notification_manager_queue_1.NotificationManagerQueue; } });
const events_1 = require("./events");
Object.defineProperty(exports, "NotificationManagerQueueReadyEvent", { enumerable: true, get: function () { return events_1.NotificationManagerQueueReadyEvent; } });
const main_1 = __importDefault(require("./main"));
require('../notification.scss');
main_1.default.initialize();
